import { render } from "./PersonalBiography.vue?vue&type=template&id=5c6a2032&scoped=true"
import script from "./PersonalBiography.vue?vue&type=script&lang=js"
export * from "./PersonalBiography.vue?vue&type=script&lang=js"

import "./PersonalBiography.vue?vue&type=style&index=0&id=5c6a2032&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c6a2032"

export default script